import _ from 'lodash'

export default selfReportCtrl

/** @ngInject */
function selfReportCtrl($scope, $state, $stateParams, SelfReport, DeviceChecker, ApiService, PrmUtilsService, ErrorCatcher) {
    window.currentScope = $scope
    $scope.isMobile = DeviceChecker.isMobile
    $scope.currentStep = 'state-initial'
    $scope.viewState = {
        displayLocateCounter: false,
        housingType: '',
        counterType: '',
        counterNumber: 0,
        communicating: false,
        planType: '',
        error: null,
        errorMessages: null,
        releve: {
            base: undefined,
            hp: undefined,
            hc: undefined,
        },
    }

    const planTypeReference = {
        BASE: 10,
        HPHC: 20,
    }
    const arianeSteps = {
        cestParti: {
            current: 1,
            achievementStyle: { width: '0%' },
        },
        localiserLeCompteur: {
            current: 2,
            achievementStyle: { width: '27%' },
        },
        identifierLeCompteur: {
            current: 3,
            achievementStyle: { width: '52%' },
        },
        envoyerLaReleve: {
            current: 4,
            achievementStyle: { width: '77%' },
        },
        fin: {
            current: 5,
            achievementStyle: { width: '77%' },
        },
    }

    $scope.step = {
        'state-initial': {
            title: '',
            arianeStep: arianeSteps.cestParti,
            next() {
                $scope.viewState.error = null
                $scope.viewState.errorMessages = null
                if ($scope.viewState.displayLocateCounter) {
                    if ($scope.viewState.housingType === 'house') {
                        // Premiere autoreleve OUI -Paysage energetique maison
                        $scope.currentStep = 'state-1-maison'
                    } else if ($scope.viewState.housingType === 'apartment') {
                        // Premiere autoreleve OUI -Paysage energetique immeuble
                        $scope.currentStep = 'state-1-immeuble'
                    }
                    // Premiere autoreleve OUI -Paysage energetique aucun
                    $scope.currentStep = 'state-1-unknown'
                } else if (PrmUtilsService.isEMC($scope.viewState.counterType) && ($scope.viewState.planType === planTypeReference.BASE)) {
                    $scope.currentStep = 'state-3-emc-base'
                } else if (PrmUtilsService.isEMC($scope.viewState.counterType) && ($scope.viewState.planType === planTypeReference.HPHC)) {
                    $scope.currentStep = 'state-3-emc-hc'
                } else if (PrmUtilsService.isCBE($scope.viewState.counterType) && ($scope.viewState.planType === planTypeReference.BASE)) {
                    $scope.currentStep = 'state-3-cbe-base'
                } else if (PrmUtilsService.isCBE($scope.viewState.counterType) && ($scope.viewState.planType === planTypeReference.HPHC)) {
                    $scope.currentStep = 'state-3-cbe-hp'
                } else if (PrmUtilsService.isLinky($scope.viewState.counterType) && !$scope.viewState.communicating && $scope.viewState.planType === planTypeReference.HPHC) {
                    $scope.currentStep = 'state-3-cbe-hp'
                } else if (PrmUtilsService.isLinky($scope.viewState.counterType) && !$scope.viewState.communicating && $scope.viewState.planType === planTypeReference.BASE) {
                    $scope.currentStep = 'state-3-cbe-base'
                } else if ($scope.viewState.communicating) {
                    $scope.currentStep = 'state-6-linky'
                } else {
                    $scope.step['state-initial'].nextError({ message: 'Impossible de déterminer le type de compteur' })
                }
            },
            nextError(error) {
                $scope.viewState.error = error
                $scope.viewState.errorMessages = _.castArray(error.data ? error.data.message : undefined)
                if ((error.data ? error.data.message : undefined) === 'Token non défini dans l’url') {
                    $scope.currentStep = 'state-error-token-invalid'
                } else if (__guard__(error.data ? error.data.message : undefined, (x) => x.indexOf('"token" length must be 40 characters long')) > -1) {
                    $scope.currentStep = 'state-error-token-invalid'
                } else if ((error.data ? error.data.message : undefined) === 'Le token a expiré.') {
                    $scope.currentStep = 'state-error-token-invalid'
                } else {
                    $scope.currentStep = 'state-error'
                    ErrorCatcher.catchError(error)
                }
            },
        },
        'state-1-maison': {
            title: 'Trouver mon compteur',
            arianeStep: arianeSteps.localiserLeCompteur,
            next() {
                if (PrmUtilsService.isCBE($scope.viewState.counterType)) {
                    $scope.currentStep = 'state-2-cbe-find-counter'
                } else {
                    $scope.currentStep = 'state-2-emc-find-counter'
                }
            },
        },
        'state-1-immeuble': {
            title: 'Trouver mon compteur',
            arianeStep: arianeSteps.localiserLeCompteur,
            next() {
                if (PrmUtilsService.isCBE($scope.viewState.counterType)) {
                    $scope.currentStep = 'state-2-cbe-find-counter'
                } else {
                    $scope.currentStep = 'state-2-emc-find-counter'
                }
            },
        },
        'state-1-unknown': {
            title: 'Trouver mon compteur',
            arianeStep: arianeSteps.localiserLeCompteur,
            next() {
                if (PrmUtilsService.isCBE($scope.viewState.counterType)) {
                    $scope.currentStep = 'state-2-cbe-find-counter'
                } else {
                    $scope.currentStep = 'state-2-emc-find-counter'
                }
            },
        },
        'state-2-cbe-find-counter': {
            title: 'Trouver mon compteur',
            arianeStep: arianeSteps.identifierLeCompteur,
            imgValues: {
                illus_CBE_serial_1() {
                    return $scope.viewState.counterNumber
                },
                illus_CBE_serial_2() {
                    return $scope.viewState.counterNumber
                },
            },
            previous() {
                if ($scope.viewState.housingType === 'house') {
                    $scope.currentStep = 'state-1-maison'
                } else if ($scope.viewState.housingType === 'apartment') {
                    $scope.currentStep = 'state-1-immeuble'
                } else {
                    $scope.currentStep = 'state-1-unknown'
                }
            },
            next() {
                $scope.viewState.displayLocateCounter = false
                $scope.currentStep = 'state-initial'
                $scope.step['state-initial'].next()
            },
        },
        'state-2-emc-find-counter': {
            title: 'Trouver mon compteur',
            arianeStep: arianeSteps.identifierLeCompteur,
            imgValues: {
                illus_EMC_serial() {
                    return $scope.viewState.counterNumber
                },
            },
            previous() {
                if ($scope.viewState.housingType === 'house') {
                    $scope.currentStep = 'state-1-maison'
                } else if ($scope.viewState.housingType === 'apartment') {
                    $scope.currentStep = 'state-1-immeuble'
                } else {
                    $scope.currentStep = 'state-1-unknown'
                }
            },
            next() {
                $scope.viewState.displayLocateCounter = false
                $scope.currentStep = 'state-initial'
                $scope.step['state-initial'].next()
            },
        },
        'state-3-emc-base': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                EMC_base_reading() {
                    return $scope.viewState.releve.base
                },
            },
            isValid() {
                return $scope.viewState.releve.base > 0
            },
            next() {
                $scope.step['state-5-submitting'].next()
            },
        },
        'state-3-emc-hc': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                EMC_HC_reading() {
                    return $scope.viewState.releve.hc
                },
                EMC_HP_reading() {
                    return $scope.viewState.releve.hp
                },
            },
            isValid() {
                return $scope.viewState.releve.hc > 0
            },
            next() {
                $scope.currentStep = 'state-4-emc-hp'
            },
        },
        'state-3-cbe-base': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                CBE_base_reading() {
                    return $scope.viewState.releve.base
                },
            },
            isValid() {
                return $scope.viewState.releve.base > 0
            },
            next() {
                $scope.step['state-5-submitting'].next()
            },
        },
        'state-3-cbe-hp': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                CBE_HC_reading() {
                    return $scope.viewState.releve.hc
                },
                CBE_HP_reading() {
                    return $scope.viewState.releve.hp
                },
            },
            isValid() {
                return $scope.viewState.releve.hp > 0
            },
            next() {
                $scope.currentStep = 'state-4-cbe-hc'
            },
        },
        'state-4-emc-hp': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                EMC_HC_reading() {
                    return $scope.viewState.releve.hc
                },
                EMC_HP_reading() {
                    return $scope.viewState.releve.hp
                },
            },
            isValid() {
                return $scope.viewState.releve.hp > 0
            },
            previous() {
                $scope.currentStep = 'state-3-emc-hc'
            },
            next() {
                $scope.step['state-5-submitting'].next()
            },
        },
        'state-4-cbe-hc': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            imgValues: {
                CBE_HC_reading() {
                    return $scope.viewState.releve.hc
                },
                CBE_HP_reading() {
                    return $scope.viewState.releve.hp
                },
            },
            isValid() {
                return $scope.viewState.releve.hc > 0
            },
            previous() {
                $scope.currentStep = 'state-3-cbe-hp'
            },
            next() {
                $scope.step['state-5-submitting'].next()
            },
        },
        'state-5-submitting': {
            title: 'Relever mon compteur',
            arianeStep: arianeSteps.envoyerLaReleve,
            next(params) {
                $scope.currentStep = 'state-5-submitting'
                SelfReport.post({
                    token: $stateParams.token,
                    force: _.get(params, 'force', false),
                }, $scope.viewState.releve).$promise
                .then((response) => {
                    if (response && response.status === 'SUCCESS') {
                        ApiService.resetPromise('userInfo')
                        $scope.currentStep = 'state-6-success'
                    } else if (response && response.status === 'WARNING') {
                        $scope.step['state-5-submitting'].nextError({
                            data: {
                                display: true,
                                message: response.message,
                                canForce: true,
                            },
                        })
                    } else {
                        let message
                        if (response && response.type) {
                            switch (response.type) {
                                case 'LINKY':
                                    message = 'Les auto-relèves ne sont pas acceptées pour les compteurs Linky.'
                                    break
                                case 'ENEDIS':
                                    message = 'Une erreur technique est survenue lors de la transmission à Enedis.'
                                    break
                                case 'CONS_INF_0':
                                    message = 'La relève saisie est inférieure à la dernière relève réelle. Nous vous recontacterons pour vous indiquer la marche à suivre.'
                                    break
                                default:
                                    message = 'Une erreur technique est survenue.'
                            }
                        } else {
                            message = 'Une erreur technique est survenue.'
                        }
                        $scope.step['state-5-submitting'].nextError({
                            data: {
                                display: true,
                                message,
                                canForce: false,
                            },
                        })
                    }
                })
                .catch((error) => {
                    ErrorCatcher.catchError(error)
                    $scope.step['state-5-submitting'].nextError(error)
                })
            },
            nextError(error) {
                $scope.viewState.error = error
                $scope.viewState.errorMessages = _.castArray(error.data ? error.data.message : undefined)
                $scope.currentStep = _.get(error, 'data.canForce', false) ? 'state-warning-submit' : 'state-error-submit'
                ErrorCatcher.catchError(error)
            },
        },
        'state-6-success': {
            title: 'Auto relève',
            arianeStep: arianeSteps.fin,
            next() {
                // Nothing to do
                $state.go('landing')
            },
        },
        'state-6-linky': {
            title: 'Auto relève',
            arianeStep: arianeSteps.fin,
            next() {
                // Nothing to do
                $state.go('landing')
            },
        },
        'state-error': {
            title: 'Erreur au chargement',
            arianeStep: arianeSteps.cestParti,
        },
        'state-error-token-invalid': {
            title: 'Lien invalide',
            arianeStep: arianeSteps.cestParti,
        },
        'state-warning-submit': {
            title: 'Attention',
            arianeStep: arianeSteps.envoyerLaReleve,
            next(params) {
                $scope.step['state-5-submitting'].next(params)
            },
        },
        'state-error-submit': {
            title: 'Echec',
            arianeStep: arianeSteps.envoyerLaReleve,
        },
    }

    $scope.skipLocateCounter = {
        isVisible() {
            const visibleOnStep = [
                'state-1-maison',
                'state-1-immeuble',
                'state-1-unknown',
                'state-2-cbe-find-counter',
                'state-2-emc-find-counter',
            ]
            return visibleOnStep
            .indexOf($scope.currentStep) > -1
        },
        skip() {
            $scope.viewState.displayLocateCounter = false
            $scope.currentStep = 'state-initial'
            $scope.step['state-initial'].next()
        },
    }

    $scope.localizeCounter = {
        isVisible() {
            const visibleOnStep = [
                'state-3-emc-base',
                'state-3-emc-hc',
                'state-3-cbe-base',
                'state-3-cbe-hp',
            ]
            return visibleOnStep.indexOf($scope.currentStep) > -1
        },
        localize() {
            $scope.viewState.displayLocateCounter = true
            $scope.currentStep = 'state-initial'
            $scope.step['state-initial'].next()
        },
    }

    const activate = function () {
        if (_.isEmpty($stateParams.token)) {
            const error = _.set({}, 'data.message', 'Token non défini dans l’url')
            $scope.step['state-initial'].nextError(error)
            ErrorCatcher.catchError(error)
        } else {
            SelfReport.get({ token: $stateParams.token }).$promise
            .then((result) => {
                $scope.viewState.housingType = result.housing_king
                $scope.viewState.displayLocateCounter = result.first
                $scope.viewState.counterType = result.metter_kind
                $scope.viewState.counterNumber = result.metter_number
                $scope.viewState.communicating = result.communicating
                $scope.viewState.planType = result.plan_id
                $scope.step['state-initial'].next()
            })
            .catch((error) => {
                $scope.step['state-initial'].nextError(error)
                ErrorCatcher.catchError(error)
            })
        }
    }

    activate()
}
function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/states/selfReport/selfReport.js